module.exports = require("core-js/library/fn/object/assign");